import { B2BAgreementType } from 'types/organization';

export const B2B_AGREEMENT_TYPE_OPTIONS: { label: string; value: B2BAgreementType }[] = [
    { label: 'Referral Agreement', value: 'referral' },
    { label: 'Sub-contractor Agreement', value: 'subcontractor' },
    { label: 'Master Service Agreement (MSA)', value: 'msa' },
    { label: 'Revenue Sharing Agreement', value: 'revenue-sharing' },
    { label: 'NDA / Confidentiality', value: 'nda' },
    { label: 'Preferred Partner Agreement', value: 'preferred-partner' },
];

export const B2B_AGREEMENT_TYPE_LABELS: Record<B2BAgreementType, string> = {
    referral: 'Referral Agreement',
    subcontractor: 'Sub-contractor Agreement',
    msa: 'Master Service Agreement (MSA)',
    'revenue-sharing': 'Revenue Sharing Agreement',
    nda: 'NDA / Confidentiality',
    'preferred-partner': 'Preferred Partner Agreement',
};
